<script>
import {batchUpdateTime} from "@/api/tracker/sea";

export default {
  props: {
    close: {
      type: Function,
    }
  },
  data() {
    return {
      formItem: {
        keywords: '',
        timeType: '',
        timeValue: ''
      },
      ruleValidate: {
        keywords: [
          {required: true, message: '海运单号不能为空', trigger: 'blur'},
        ],
        timeType: [
          {required: true, message: '时间类型不能为空', trigger: 'blur'},
        ],
        timeValue: [
          {required: true, message: '轨迹时间不能为空', trigger: 'change', type: 'date'},
        ],
      },
      loading: false,
    }
  },
  methods: {
    updateValue() {
      this.$refs['formValidate'].validate(valid => {
        if (valid) {
          this.loading = true;
          // 提交数据
          batchUpdateTime(this.formItem).then(res => {
            this.loading = false
            if (res.data.status) {
              this.$Message.success({
                content: res.data.msg,
                duration: 5,
                onClose: () => {
                  this.$parent.$parent.$page.getList()
                  this.close()
                }
              });
            } else {
              this.$Message.error(res.data.msg);
            }
          })
        }
      })
    }
  }
}
</script>

<template>
  <Form :model="formItem" :label-width="80" ref="formValidate" :rules="ruleValidate" >
    <FormItem label="订单号" prop="keywords">
      <Input v-model="formItem.keywords" type="textarea" :rows="5" placeholder="请输入海运单号，每行一个"></Input>
    </FormItem>
    <FormItem label="时间类型" prop="timeType">
      <Select v-model="formItem.timeType">
        <Option value="depart_date">离港时间</Option>
        <Option value="dept_date">预计离港时间</Option>
        <Option value="expected_date">预计到港时间</Option>
        <Option value="arrival_date">到达目的港时间</Option>
        <Option value="clearance_date">清关时间</Option>
      </Select>
    </FormItem>
    <FormItem label="录入时间" prop="timeValue">
      <DatePicker type="datetime" placeholder="请选择一个日期" v-model="formItem.timeValue" style="width: 200px"></DatePicker>
    </FormItem>

    <FormItem>
      <Button type="primary" :loading="loading" @click="updateValue">录入数据</Button>
    </FormItem>
  </Form>
</template>

<style scoped>

</style>
